import { Navigate, useLocation } from "react-router-dom";
import { useAuthStatus } from "./session";
import { AuthSplash } from "./AuthSplash";
import { CheckEmailScreen } from "./CheckEmailScreen";
import { ForwardAfterAuth } from "./ForwardAfterAuth";
import { LOGIN_PATH } from "./paths";
import { AUTH_ENABLED } from "./config";

/* The /check-email route — the home of the "unverified" auth status. Only an
 * unverified session renders the screen; everyone else is redirected:
 * authenticated → forwarded by nextAfterAuth (so an invite/redirect carried
 * into the URL survives the detour), anonymous → /login. When auth is disabled
 * there is no verification gate, so it bounces to the dashboard. */
export function CheckEmailRoute() {
  if (!AUTH_ENABLED) return <Navigate to="/" replace />;

  return <CheckEmailGate />;
}

function CheckEmailGate() {
  const { status } = useAuthStatus();
  const location = useLocation();

  if (status === "loading") return <AuthSplash />;

  // Verified now (e.g. "I've verified" reloaded with the session verified):
  // forward like LoginRoute — lands an invited user on /invite/:id, or honors
  // a `redirect` (full browser hop — may target a sibling app), else home.
  if (status === "authenticated") {
    return <ForwardAfterAuth search={location.search} />;
  }

  // No session — back to /login, preserving any invite/redirect query.
  if (status === "anonymous") {
    return <Navigate to={`${LOGIN_PATH}${location.search}`} replace />;
  }

  // status === "unverified"
  return <CheckEmailScreen />;
}
